import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ScanLine, FileText, PhoneCall, MessageCircle } from "lucide-react";
import CallbackModal from "./CallbackModal";
import { PHONE_TEL } from "../data/contact";
import { ACTS, DEFAULT_WA, MOBILE_URL, SPORT_PARAMS, waLink } from "../data/showcase";

const AdsBar = ({ search }) => {
  const variant = SPORT_PARAMS[(new URLSearchParams(search).get("sport") || "").toLowerCase()] || null;
  const act = variant ? ACTS[variant.slug] : null;
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 glass border-t border-white/10 flex pb-[env(safe-area-inset-bottom)]" data-testid="sticky-actions-ads">
      <a href={PHONE_TEL} data-testid="sticky-ads-call"
         className="flex-1 flex items-center justify-center gap-2 py-4 text-sm font-bold text-gold border-r border-white/10">
        <PhoneCall size={18} /> Call
      </a>
      <a href={waLink(act?.whatsapp || DEFAULT_WA)} target="_blank" rel="noopener noreferrer" data-testid="sticky-ads-whatsapp"
         className="flex-1 flex items-center justify-center gap-2 py-4 text-sm font-bold text-neon border-r border-white/10">
        <MessageCircle size={18} /> WhatsApp
      </a>
      <Link to="/quote" state={{ sport: act?.sport || null, source: variant ? variant.slug : "mobile-ads" }} data-testid="sticky-ads-quote"
            className="flex-1 flex items-center justify-center gap-2 py-4 text-sm font-bold text-obsidian bg-gold">
        <FileText size={18} /> Get Quote
      </Link>
    </div>
  );
};

// Mobile-only sticky action bar
export default function StickyActions() {
  const loc = useLocation();
  const [callback, setCallback] = useState(false);
  if (loc.pathname.startsWith("/admin")) return null;
  if (loc.pathname === MOBILE_URL) return <AdsBar search={loc.search} />;
  return (
    <>
      <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 glass border-t border-white/10 flex pb-[env(safe-area-inset-bottom)]" data-testid="sticky-actions">
        <button onClick={() => setCallback(true)} data-testid="sticky-callback-btn"
          className="flex-1 flex items-center justify-center gap-2 py-4 text-sm font-bold text-gold border-r border-white/10">
          <PhoneCall size={18} /> Call Back
        </button>
        <Link to="/court-scan" data-testid="sticky-scan-btn"
          className="flex-1 flex items-center justify-center gap-2 py-4 text-sm font-bold text-neon border-r border-white/10">
          <ScanLine size={18} /> Scan
        </Link>
        <Link to="/quote" data-testid="sticky-quote-btn"
          className="flex-1 flex items-center justify-center gap-2 py-4 text-sm font-bold text-obsidian bg-neon">
          <FileText size={18} /> Quote
        </Link>
      </div>
      <CallbackModal open={callback} onClose={() => setCallback(false)} />
    </>
  );
}
